import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Setting';

const settings = [
  {
    matchRegex: '/Setting',
    name: getRouteName(MODULE_NAME, 'Home'),
    slots: [
      SLOT_KEY.SLOT_LIST_GRID,
      SLOT_KEY.SLOT_SCRIPTS,
    ],

  },
  {
    matchRegex: '/Setting/AccountIntegration',
    name: getRouteName(MODULE_NAME, 'Account Integration'),
    slots: [
      SLOT_KEY.SLOT_SECTION,
    ],
    parentKeys: {
      [SLOT_KEY.SLOT_SECTION]: [
        { key: 'wrapper-section-list', label: 'Wrapper section' },
      ],
    },
  },
  {
    matchRegex: '/Setting/SystemSetup',
    name: getRouteName(MODULE_NAME, 'System Set up'),
    slots: [SLOT_KEY.SLOT_TAB],
  },
  {
    matchRegex: '/Setting/CompanySetup',
    name: getRouteName(MODULE_NAME, 'Company Set up'),
    slots: [SLOT_KEY.SLOT_TAB],
  },
];

export default settings;
